

<template>
  <div class="w-full max-w-4xl mx-auto bg-[#111113] rounded-2xl p-6 md:p-10 shadow-lg text-center flex flex-col items-center">
    <div class="mb-6 flex flex-col items-center">
      <img src="/src/assets/nasna-logo.png" alt="Nasna" class="w-16 md:w-20 mb-2" />
      <h2 class="text-lg md:text-xl lg:text-2xl font-bold text-white mb-1">اختر الباقة المناسبة</h2>
      <div class="text-gray-400 text-sm md:text-base">خطوة 1 من 2</div>
    </div>
    <div class="w-full mb-6 flex flex-col gap-4">
      <PlanCard
        v-for="(plan, idx) in plans"
        :key="plan.period"
        v-bind="plan"
        :selected="selected === idx"
        @select="selectPlan(idx)"
      />
    </div>
    <button
      class="w-full bg-[#CB34C5] text-white rounded-md py-2 md:py-3 text-base md:text-lg font-bold mb-3 transition-colors duration-200 hover:bg-[#a0269e]"
      @click="$emit('continue', plans[selected])"
    >المتابعة</button>
    <button
      class="w-full bg-transparent text-white text-sm md:text-base  cursor-pointer border py-2 px-6 rounded-md"
      @click="$emit('back')"
    >الرجوع</button>
  </div>
</template>

<script>
import PlanCard from './PlanCard.vue';
export default {
  name: 'PlansList',
  components: { PlanCard },
  props: {
    plans: Array,
    selected: Number
  },
  methods: {
    selectPlan(idx) {
      this.$emit('update:selected', idx);
    }
  }
}
</script>


<!-- All styles are now handled by Tailwind CSS classes in the template -->
